import React from "react";
import { Navigate } from "react-router-dom";

const Authmiddleware = (props) => {
  // 
  const token =
    localStorage.getItem("usertoken") ||
    localStorage.getItem("token");

  // 
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;
